import { FC } from "react";
import { connectMenu } from "react-instantsearch-dom";
import { MenuProvided } from "react-instantsearch-core";
import { Box } from "@otrium/core";
import styled from "@emotion/styled";
import { Radio } from "src/atoms/Radio";
import { useFilterApplied } from "src/organisms/AlgoliaProductList/useFilterApplied";
import {
  ContentWrapper,
  FilterContent,
} from "src/organisms/AlgoliaProductList/MobileFilterView/MobileFilters.styled";

const StyledDiscount = styled(Radio)`
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  color: ${({ theme }) => theme.colors.tone.black};
  line-height: 1.5;
  letter-spacing: 0.4px;
`;

const Wrapper = styled(Box)`
  border-bottom: solid 1px ${({ theme }) => theme.colors.primary.platinumLight};
  letter-spacing: normal;
  line-height: 25px;

  &:last-of-type {
    border-bottom: none;
  }
`;

const DiscountFilterSelect: FC<MenuProvided> = ({ items, refine }) => {
  const { handleRefine } = useFilterApplied(items, refine);

  if (!items.length) {
    return null;
  }

  return (
    <FilterContent>
      <ContentWrapper>
        {items.map((item) => {
          const splitLabel = item.label.split("||");
          const label = splitLabel[1];
          return (
            <Wrapper py={3} key={label}>
              <StyledDiscount
                checked={item.isRefined}
                name={label}
                onChange={handleRefine(item.value as unknown as string[])}
              />
            </Wrapper>
          );
        })}
      </ContentWrapper>
    </FilterContent>
  );
};

const DiscountFilter = connectMenu(DiscountFilterSelect);

export default DiscountFilter;
